module.exports = __webpack_public_path__ + "img/icon_matching_w.32b2c4d9.svg";